import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from '@material-ui/core/Grid';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbIntroGalleryBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`intro-gallery ${props.attributes.className ? props.attributes.className : ''} ${classes.introGallery} ${classes.introGalleryTheme}`}>
        <Grid container spacing={3} direction="row" justiy="center" alignItems="center">
            <Grid item xs={12} md={7} lg={6} className='con-wrap'>
                {blocks[0]}
                {blocks[1]}
                {props.attributes.hasButton &&
                    <>{blocks[3]}</>
                }
            </Grid>
            <Grid item xs={12} className="image-wrap">
                {blocks[2]}
            </Grid>
        </Grid>
    </div>
};

export const CgbIntroGalleryBlockFragment = graphql`
  fragment CgbIntroGalleryBlock on WpBlock {
    ... on WpCgbIntroGalleryBlock {
        name
        attributes {
            className
            hasButton
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbIntroGalleryBlockPreview = `
    ... on CgbIntroGalleryBlock {
        name
        attributes {
            className
            hasButton
        }
    }
`;